import useApi from "./useApi";

/**
 * Custom hook for serving related actions
 */
const useServing = (job) => {
    const { postJson, getJson } = useApi();

    /**
     * Submit a serving signature for the job.
     * @param {string} dpid 
     * @returns 
     */
    const submitSignature = async (dpid) => {
        if (job === null || job.dpid === undefined) {
            return;
        }

        const data = JSON.stringify({
            id: job.dpid,
            serving_type: 'online'
        });


        return await postJson('/online/signserving', data);
    }

    /**
     * Fetch usage place information for the given dpid.
     * 
     * @param {string} dpid 
     * @returns {Promise<Object|undefined>} Object containing usage place information (id and address of usageplace)
     */
    const fetchUsagePlaceInfo = async (dpid) => {
        if (job === null || job.dpid === undefined) {
            return;
        }

        try {
            const response = await getJson(`/online/usageplace/${dpid}`);

            return {
                id: response?.data[0]?.usageplace_id,
                address: formatAddresses(response?.data[0]?.address[0])
            };
        } catch (error) {
            if (error.response?.status === 404 && error.response?.data?.title === "Usage place not found") {
                // leave usageplace information empty if not found, no need to throw error
                return {
                    id: null,
                    address: null
                };
            } else {
                throw error;
            }
        }
    }

    /**
     * Format the gived address object into a string where values are separated with a comma (,),
     * except for the last values (postcode and city).
     * 
     * @param {Object} addressArray 
     * @returns {string} Formatted address string, e.g. "Street 123, Address Line 1, 00100 Helsinki"
     */
    const formatAddresses = (addressArray) => {
        if (!addressArray) {
            return ''
        };

        const addressParts = [
            addressArray.address,
            addressArray.addressaddline1,
            addressArray.addressaddline2,
            addressArray.addressaddline3,
            `${addressArray.postcode} ${addressArray.city}`.trim()
        ];

        // remove falsy values (null, undefined, empty strings) and whitespace-only strings
        return addressParts.filter(Boolean).filter(item => item.trim()).join(", ");
    }

    return {
        submitSignature,
        fetchUsagePlaceInfo,
        formatAddresses
    };
}

export default useServing;